module.exports = __webpack_public_path__ + "lowisko-logo.bfe03a1.png";